import { BillingStatus } from '@/api/projects';
import type { BadgeProps } from '@/components/ui/badge';

/**
 * Single source of truth for how a project's billing status renders across the
 * super-admin surfaces (Billing overview, Projects list, project detail +
 * history). Kept in one place so the label text and badge colour can't drift
 * between screens (PR #1695 review — the label was previously defined three
 * times, one of them rendering the raw enum).
 *
 * QUOTED is retired as a selectable option but still renders a label/variant so
 * legacy rows that carry it stay legible (TELV1-524). null/undefined = the
 * default "New" status (stored as null, no migration).
 */
export function getBillingStatusLabel(status?: BillingStatus | null): string {
  switch (status) {
    case BillingStatus.QUOTED:
      return 'Quoted';
    case BillingStatus.INVOICED:
      return 'Invoiced';
    case BillingStatus.PAID:
      return 'Paid';
    case BillingStatus.FREE:
      return 'Free';
    default:
      return 'New';
  }
}

export function getBillingBadgeVariant(status?: BillingStatus | null): BadgeProps['variant'] {
  switch (status) {
    case BillingStatus.QUOTED:
      return 'warning';
    case BillingStatus.INVOICED:
      return 'info';
    case BillingStatus.PAID:
      return 'success';
    case BillingStatus.FREE:
      return 'free';
    // null/undefined = "New"
    default:
      return 'default';
  }
}
